// extracted by mini-css-extract-plugin
export default {"emptyText":"Empty_emptyText__94PLy"};